import { Language, LanguageMap } from '@coolblue-development/constants';

export const LocalizedReadableLanguageMap: LanguageMap<LanguageMap<string>> = {
  [Language.ENGLISH]: {
    [Language.ENGLISH]: 'English',
    [Language.FRENCH]: 'Anglais',
    [Language.DUTCH]: 'Engels',
    [Language.GERMAN]: 'Englisch'
  },
  [Language.FRENCH]: {
    [Language.ENGLISH]: 'French',
    [Language.FRENCH]: 'Français',
    [Language.DUTCH]: 'Frans',
    [Language.GERMAN]: 'Französisch'
  },
  [Language.DUTCH]: {
    [Language.ENGLISH]: 'Dutch',
    [Language.FRENCH]: 'Néerlandais',
    [Language.DUTCH]: 'Nederlands',
    [Language.GERMAN]: 'Niederländisch'
  },
  [Language.GERMAN]: {
    [Language.ENGLISH]: 'German',
    [Language.FRENCH]: 'Allemand',
    [Language.DUTCH]: 'Duits',
    [Language.GERMAN]: 'Deutsch'
  }
};
